import BaseUtil from "../../../util/BaseUtil";

const type = `@@ActionType/UPDATE@${__filename}`;

const initState = {
    isLoading: false,

    units: null,
    originUnitTree: null,
    unitTree: null,

    checkeds: [],
    disableds: [],
    expandedRows: null,

    bizUnitEdit: {
        isVisible: false,
        isSaving: false,

        units: null,
        parentId: null,
    },

    matronEdit: {
        isVisible: false,
        isSaving: false,

        unit: null,
    },

    unitImport: {
        isVisible: false,
        isSaving: false,

        units: null,
    },

    unitSortSettingModalVisible: false,
};

const [
    viewModel,
    update, reset,
    updateBizUnitEdit, resetBizUnitEdit,
    updateMatronEdit, resetMatronEdit,
    updateUnitImport, resetUnitImport,

] = BaseUtil.getViewModel(initState, type, "bizUnitEdit", "matronEdit", "unitImport");

export {
    update, reset,
    updateBizUnitEdit, resetBizUnitEdit,
    updateMatronEdit, resetMatronEdit,
    updateUnitImport, resetUnitImport,
};
export default viewModel;